<template>
  <b-card
    title="مدیریت تنوع محصول"
  >
    <b-row>
      <b-col
        class="table-size"
      >
        <div class="custom-search">
          <b-row>
            <div class="filter-row">
              <b-button
                class="mb-1 ml-1"
                variant="primary"
                :to="{ name: 'addproductvariety', query:{ productid: filterOptions.ProductId }}"
              >
                جدید
              </b-button>
              <b-button
                variant="info"
                class="mb-1 mr-auto ml-1"
                @click="showBulkAddModal"
              >
                درج گروهی
              </b-button>

              <b-col md="2">
                <b-form-group
                  label="عنوان"
                  label-for="Title"
                >
                  <b-form-input
                    v-model="filterOptions.Title"
                    @keyup.enter="update(1)"
                  />
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group>
                  <label>وضعیت</label>
                  <v-select
                    v-model="filterOptions.Status"
                    :options="enums('ProductStatus')"
                    dir="rtl"
                    label="text"
                    :reduce="x => x.value"
                  />
                </b-form-group>
              </b-col>
              <b-button
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                class="mb-1 mr-1"
                variant="warning"
                @click="update(1)"
              >فیلتر
              </b-button>
            </div>
          </b-row>
        </div>

        <b-table
          bordered
          hover
          striped
          :items="items"
          :fields="fields"
          class="mt-1 mb-2 position-relative"
          responsive
          :busy="loading"
        >
          <template #cell(Id)="data">
            <b-link
              :to="{ name: 'updateproductvariety', params: { id: data.value }, query:{ productid: filterOptions.ProductId }}"
              class="font-weight-bold"
            >
              #{{ data.value }}
            </b-link>
          </template>

          <template #cell(Price)="data">
            {{ data.value | price }}
          </template>

          <template #cell(Discount)="data">
            {{ data.value | price }}
          </template>

          <template #cell(Quantity)="data">
            {{ data.value | price }}
          </template>

          <template #cell(IsDefault)="data">
            <b-form-checkbox
              v-model="data.item.IsDefault"
              name="check-button"
              switch
              :disabled="data.item.IsDefault"
              @change="setDefault(data.item)"
            />
          </template>

          <template #cell(ProductVarietyAttribute)="data">
            <b-badge
              v-for="item in data.value"
              variant="light-secondary"
              style="line-height: unset; margin: 2px;"
            >
              {{ item.Title }}
            </b-badge>
          </template>

          <template #cell(Status)="data">
            <b-badge
              :variant="enums('ProductStatus', 'value', data.value, 'badge')"
            >
              {{ enums('ProductStatus', 'value', data.value, 'text') }}
            </b-badge>
          </template>

          <template #cell(actions)="data">

            <div
              class="text-nowrap"
            >
              <b-link
                :to="{ name: 'duplicateproductvariety', params: { id: data.item.Id }, query:{ productid: filterOptions.ProductId }}"
              >
                <feather-icon
                  :id="`invoice-row-${data.item.Id}-copy-icon`"
                  icon="CopyIcon"
                  size="16"
                />
              </b-link>

              <b-link :to="{ name: 'updateproductvariety', params: { id: data.item.Id }, query:{ productid: filterOptions.ProductId }}">
                <feather-icon
                  :id="`invoice-row-${data.item.Id}-send-icon`"
                  icon="EditIcon"
                  size="16"
                  class="ml-1"
                />
              </b-link>

              <feather-icon

                icon="TrashIcon"
                size="16"
                class="ml-1 cursor-pointer"
                @click="remove(data.item.Id)"
              />
            </div>
          </template>

          <template #table-busy>
            <div
              class="text-center my-2"
            >
              <b-spinner
                variant="primary"
                class="align-middle"
              />
              <strong class="ml-1">در حال دریافت اطلاعات ...</strong>
            </div>
          </template>

          <template #table-busy>
            <div
              class="text-center my-2"
            >
              <b-spinner
                variant="primary"
                class="align-middle"
              />
              <strong class="ml-1">در حال دریافت اطلاعات ...</strong>
            </div>
          </template>

        </b-table>

        <z-pagination
          :page="filterOptions.Page"
          :total-rows="totalRows"
          :loading="loading"
          @change="update"
        />

      </b-col>

    </b-row>

    <b-modal
      v-if="showModal"
      v-model="showModal"
      ok-title="ذخیره"
      cancel-title="انصراف"
      cancel-variant="outline-secondary"
      centered
      title="درج گروهی"
      :no-close-on-backdrop="true"
      size="md"
      class="bulk-update-modal"
      @ok="bulkAddSave"
    >
      <b-row>
        <b-col
          v-for="(item, index) in ProductAttribute"
          md="12"
        >
          <b-form-group
            :label="item.Title"
            :label-for="'ProductAttribute'+ index"
          >
            <b-form-tags
              v-model="item.Description"
              placeholder=""
              add-button-text="افزودن"
              add-button-variant="outline-primary"
            />
          </b-form-group>
        </b-col>

        <b-col md="6">
          <b-form-group
            label="وضعیت"
            label-for="Status"
          >
            <v-select
              v-model="Form.Status"
              :options="enums('ProductStatus')"
              dir="rtl"
              label="text"
              name="Status"
              :clearable="false"
              :reduce="x => x.value"
            />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            label="تعداد"
            label-for="Quantity"
          >
            <b-form-input
              v-model="Form.Quantity"
              autocomplete="off"
              type="number"
              name="Quantity"
            />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            label="قیمت"
            label-for="Price"
          >
            <b-input-group append="تومان">
              <cleave
                v-model="Form.Price"
                class="form-control"
                :raw="false"
                :options="options"
              />
            </b-input-group>
          </b-form-group>
        </b-col>

        <b-col md="6">
          <b-form-group
            label="تخفیف"
            label-for="Discount"
          >
            <b-input-group append="تومان">
              <cleave
                v-model="Form.Discount"
                class="form-control"
                :raw="false"
                :options="options"
              />
            </b-input-group>
          </b-form-group>
        </b-col>

      </b-row>
    </b-modal>
  </b-card>
</template>

<script>
export default {
  name: 'ProductVariety',
  data() {
    return {
      totalRows: 1000 * 1000,
      loading: false,
      filterOptions: {
        Title: null,
        Page: 1,
        Type: 0,
      },
      fields: [
        {
          key: 'Id',
          label: '#',
          thClass: 'col-width-50',
        },
        {
          key: 'ProductVarietyAttribute',
          label: 'ویژگی',
        },
        {
          key: 'Price',
          label: 'قیمت',
        },
        {
          key: 'Discount',
          label: 'تخفیف',
        },
        {
          key: 'IsDefault',
          label: 'پیش فرض',
        },
        {
          key: 'Quantity',
          label: 'تعداد',
        },
        {
          key: 'Status',
          label: 'وضعیت',
        },
        {
          key: 'actions',
          label: '',
          thClass: 'col-width-50',
        },
      ],
      items: [],
      ProductAttribute: [],
      showModal: false,
      Form: {},
      options: {
        numeral: true,
        numeralThousandsGroupStyle: 'thousand',
        numeralDecimalScale: 4,
      },
    }
  },
  created() {
    if (this.$store.state.zirehState.listFilter[this.$options.name]) {
      this.filterOptions = this.$store.state.zirehState.listFilter[this.$options.name]
    }

    this.filterOptions.ProductId = this.$route.query.productid
    this.getAllProductAttribute()
    this.update()
  },
  methods: {
    update(pageNumber) {
      this.loading = true

      this.filterOptions.Page = pageNumber || this.filterOptions.Page

      this.$store.commit('zirehState/setListFilter', { key: this.$options.name, value: this.filterOptions })

      this.$http.post(
        this.$api.productvariety.getlist, this.filterOptions,
      )
        .then(res => {
          this.totalRows = res.totalRow
          this.items = res.data
        })
        .finally(() => {
          this.loading = false
        })
    },
    setDefault(row) {
      this.loading = true

      this.$http.post(
        this.$api.productvariety.setdefault, { id: row.Id },
      )
        .then(res => {
          this.update()
        })
    },
    remove(id) {
      this.removeRow(this.$api.productvariety.remove, 'Id', id)
    },
    getAllProductAttribute() {
      this.loading = true
      this.$http.post(
        '/productattribute/getall', {
          ProductId: this.filterOptions.ProductId,
        },
      )
        .then(res => {
          this.loading = false
          this.ProductAttribute = res.data
        })
    },
    showBulkAddModal() {
      this.showModal = true
      this.Form = {
        Id: null,
        Status: 0,
        Price: null,
        Discount: null,
        Quantity: null,
        ProductId: this.filterOptions.ProductId
      }
    },
    bulkAddSave() {

      const form = JSON.parse(JSON.stringify(this.Form))

      if (form.Price) {
        form.Price = form.Price.replaceAll(',', '')
      }

      if (form.Discount) {
        form.Discount = form.Discount.replaceAll(',', '')
      }

      form.ProductVarietyAttribute = []

      this.ProductAttribute.forEach((item, index) => {
        let title = []

        if (item.Description){
          title=item.Description
        }
        form.ProductVarietyAttribute.push({ ProductAttributeId: item.Id, Title: title })
      })

      this.$http.post(
        this.$api.productvariety.bulkadd, form,
      )
        .then(() => {
          this.update()
        })
        .catch(() => {
           this.showModal = true
        })
    },
  },
}
</script>

<style scoped>

</style>
